export const CREATE_PRODUCT_RETURN = {
    REQUEST: 'COMPLAINT_SELLER.CREATE_PRODUCT_RETURN.REQUEST',
    SUCCESS: 'COMPLAINT_SELLER.CREATE_PRODUCT_RETURN.SUCCESS',
    FAILED: 'COMPLAINT_SELLER.CREATE_PRODUCT_RETURN.FAILED',
};